import { floor } from 'lodash-es';

/**
 * Abbreviate number label to nearest 1000 and append 'k' if value goes above 1000.
 *
 * @param value number value to abbreviate
 * @param precision number of decimal places to round to
 * @returns
 */
export function abbreviateNumberLabel(value: number, precision = 1): string {
  return value >= 1000 ? `${floor(value / 1000, precision)}k` : `${value}`;
}
